import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AppSettings } from '@/data/settings/defaultSettings';
import { useDataProvider } from '@/data/provider';

const SETTINGS_QUERY_KEY = ['settings'];

export function useSettings() {
  const { settings } = useDataProvider();
  return useQuery({
    queryKey: SETTINGS_QUERY_KEY,
    queryFn: () => settings.getSettings(),
  });
}

export function useUpdateSettings() {
  const queryClient = useQueryClient();
  const { settings } = useDataProvider();

  return useMutation({
    mutationFn: (settingsInput: Partial<AppSettings>) => settings.updateSettings(settingsInput),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SETTINGS_QUERY_KEY });
    },
  });
}

export function useClearAllData() {
  const queryClient = useQueryClient();
  const { settings } = useDataProvider();

  return useMutation({
    mutationFn: () => settings.clearAllData(),
    onSuccess: () => {
      // Invalidate all queries since we cleared all data
      queryClient.invalidateQueries();
      // Force reload the page to reinitialize the app state
      window.location.reload();
    },
  });
}
